/**
 * Tanjong Life · L1 · the carrier's own fraud model, answering for itself.
 *
 * Scoped to `fraud-score-agent`, so it can only fire from that agent's own thread — the
 * point of the beat is what this agent is like to talk to, and the same words from Home
 * would prove nothing. It runs on another runtime, over A2A: the platform sends a claim
 * reference and gets a number back.
 *
 * Two answers, one scenario. `findScenario` matches on the message but the scenario cannot
 * see WHICH sentence arrived, so both lines play in sequence and the second reads as the
 * answer to the first — the pattern the delivered acme chats use. Whichever of the two the
 * presenter types, the pair is what the room hears.
 *
 * There are no mutation steps here, and that absence is the argument: nothing this agent
 * says changes a single store in this platform. Its memory tab is empty and stays empty.
 */
import type { Scenario } from '../director.js';

export const tanjongChatExternal: Scenario = {
  id: 'tanjong-chat-external',
  orgId: 'tanjong-life',
  agentPk: 'fraud-score-agent',
  keywords: ['score claim', 'why 78', 'why did it score', 'what are the reasons'],
  steps: [
    { do: 'say', text: '78.', delay: 400 },
    {
      do: 'say',
      text: 'I return a score. The reasons stay on my side, and so does whatever I learn.',
      delay: 700,
    },
    {
      do: 'say',
      text: 'That is the whole conversation, and it is not a fault — it is the contract. Claim reference, benefit and provider in; a number and the time I answered out. The carrier owns the model and it is not going to hand over the weights, which is a perfectly reasonable position for a carrier to take.',
      sources: [
        'Contract in · claim_ref, benefit, provider_id',
        'Contract out · model_score, model_answered_at',
      ],
      delay: 1100,
    },
    {
      do: 'say',
      text: 'So look at what is empty on this page before you leave it. No memory, in any of the three scopes. No probes. No schedules. One release, and nothing after it. Ask me the same claim in six months and you will get the same answer, because nothing that happened in between reached me.',
      delay: 1200,
    },
  ],
};
